import getGuardTimeSchedule from 'services/data-manager/parsing/utils/getGuardTimeSchedule.ts';
import shouldConsiderCatchupAsLive from 'services/data-manager/parsing/utils/shouldConsiderCatchupAsLive.ts';
import { VideoItem } from 'services/data-manager/types';

function parseVideoItemForCU(videoItem: VideoItem): VideoItem {
    const { startTime, endTime, duration } = getGuardTimeSchedule(videoItem);

    return {
        ...videoItem,
        startTime,
        endTime,
        duration,
        sourceConfig: shouldConsiderCatchupAsLive(endTime)
            ? {
                  startOffset: 0,
                  startOffsetTimelineReference: 'start',
              }
            : videoItem.sourceConfig,
    };
}

export default parseVideoItemForCU;
